import { Stack, Typography } from "@mui/material";
import { formatDateRange } from "../../../utils/formatDateRange";
import { ExportAccountPlanBtn } from "../../ui/buttons";
import { AccountPlan } from "../../../types";
import { CopyUrlBtn } from "../../ui/buttons/CopyUrlBtn/CopyUrlBtn";
import { AppRoutes } from "../../../types/enums";

export const ContentHeader = ({
  isFixed,
  companyName,
  account_id,
  campaign_id,
  isDemo,
  accountPlan,
  isPublic,
}: {
  isFixed: boolean;
  companyName: string;
  account_id: string;
  campaign_id: string;
  isDemo: boolean;
  accountPlan: AccountPlan;
  isPublic?: boolean;
}) => {
  return (
    <Stack
      sx={
        isFixed
          ? {
              position: "fixed",
              top: `${isPublic ? 74 : isDemo ? 100 : 72}px`,
              left: 0,
              backgroundColor: "transparent",
              width: "100%",
              zIndex: 2,
            }
          : undefined
      }
    >
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap="8px"
        sx={{
          padding: "24px 32px",
          background:
            "linear-gradient(267.05deg, #1C3C70 -0.33%, #0097DD 108.14%)",
          borderRadius: "8px",
          ...(isFixed && {
            padding: { sm: "12px 40px", lg: "12px 72px" },
            position: "sticky",
            top: "72px",
            background: "none",
            backgroundColor: "#0860A8",
            width: "100vw",
            zIndex: 2,
            borderRadius: "none",
          }),
        }}
      >
        <Stack gap={isFixed ? "4px" : "8px"}>
          <Typography
            color={"white"}
            fontWeight={600}
            fontSize={!isFixed ? "32px" : "18px"}
            lineHeight={!isFixed ? "44px" : "22px"}
          >
            Account Plan for {companyName || accountPlan.company_name}
          </Typography>
          <Typography component="span" color={"white"}>
            Last update:{" "}
            {accountPlan?.updated_at
              ? formatDateRange(accountPlan.updated_at, true)
              : formatDateRange("2025-05-10T12:03:08.169948Z", true)}
          </Typography>
        </Stack>
        <Stack
          gap={isFixed ? "8px" : "12px"}
          flexDirection={isFixed ? "row" : "column"}
        >
          <ExportAccountPlanBtn
            isFixed={isFixed}
            account_id={account_id}
            campaign_id={campaign_id}
            accountPlan={accountPlan}
            companyName={companyName}
          />
          <CopyUrlBtn
            url={`${process.env.REACT_APP_BASE_URL}${AppRoutes.ACCOUNT_PLAN}/${campaign_id}/${account_id}`}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
